module.exports = __webpack_public_path__ + "img/iconmonstr-email-3.09801cfe.svg";